import { render, staticRenderFns } from "./deveHouse.vue?vue&type=template&id=f2042128&scoped=true&"
import script from "./deveHouse.vue?vue&type=script&lang=js&"
export * from "./deveHouse.vue?vue&type=script&lang=js&"
import style0 from "./deveHouse.vue?vue&type=style&index=0&id=f2042128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2042128",
  null
  
)

export default component.exports